import React from 'react';

/**
 * Modal explaining how Jesse works and what to expect from the conversation.
 * Redesigned with step-by-step visual flow.
 */
const HelpModal = ({ isVisible, onClose }) => {
  if (!isVisible) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content help-modal" onClick={e => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          <span className="material-icons">close</span>
        </button>

        <div className="modal-icon-header info">
          <span className="material-icons">info</span>
        </div>

        <h2>Hoe werkt Jesse?</h2>
        <p className="modal-subtitle">In 3 stappen naar een sterke vacaturetekst</p>

        {/* Step cards */}
        <div className="step-cards">

          <div className="step-card">
            <div className="step-card__number">1</div>
            <div className="step-card__content">
              <h3>
                <span className="material-icons">chat</span>
                Het gesprek
              </h3>
              <p>Jesse voert een natuurlijk gesprek met je. Hij stelt gerichte vragen en vraagt door waar nodig — net als een ervaren recruiter.</p>
            </div>
          </div>

          <div className="step-connector">
            <span className="material-icons">arrow_downward</span>
          </div>

          <div className="step-card">
            <div className="step-card__number">2</div>
            <div className="step-card__content">
              <h3>
                <span className="material-icons">gps_fixed</span>
                De juiste info
              </h3>
              <p>Jesse weet precies wat hij nodig heeft:</p>
              <div className="step-card__tags">
                <span className="info-tag"><span className="material-icons">badge</span> Functie</span>
                <span className="info-tag"><span className="material-icons">task_alt</span> Taken</span>
                <span className="info-tag"><span className="material-icons">checklist</span> Eisen</span>
                <span className="info-tag"><span className="material-icons">redeem</span> Aanbod</span>
              </div>
            </div>
          </div>

          <div className="step-connector">
            <span className="material-icons">arrow_downward</span>
          </div>

          <div className="step-card">
            <div className="step-card__number">3</div>
            <div className="step-card__content">
              <h3>
                <span className="material-icons">description</span>
                Het resultaat
              </h3>
              <p>Een professionele vacaturetekst — direct, helder en zonder buzzwords. Kopieer, download als PDF of verstuur via email.</p>
            </div>
          </div>
        </div>

        <div className="help-privacy-badge">
          <span className="material-icons">shield</span>
          <span>Je gesprek is privé en wordt niet gedeeld met derden</span>
        </div>

        <button className="modal-button primary" onClick={onClose}>
          <span className="material-icons">mic</span>
          Perfect, ik ga beginnen!
        </button>
      </div>
    </div>
  );
};

export default HelpModal;
